export const URL_PARAMS_KEYS = {
  next: "next",
  order: "order",
  paymentVia: "paymentVia",
  transaction: "transaction",
  transactionId: "transactionId",
};
